import { config } from './config';
import { getCustomerDetails } from '../api/customer';

export const hasInteractAdminLicense = async () => {
  const customerDetails = await getCustomerDetails();
  return !!customerDetails?.activeProducts?.find(a => a.id === config.productLicense);
};
